module.exports = __webpack_public_path__ + "static/img/icon_get_origin.1c1c78d8.svg";